export function formatPercentage (value) {
  return Number(value).toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 })
}



// WEBPACK FOOTER //
// ./src/utils/number.js